export default "__VITE_ASSET__CWjVSLXM__"